import { apiClient } from "./apiClient";
import { unwrapApiResponse, unwrapPagedItems } from "../shared/utils/apiResponse";

export async function listResource<T>(url: string, method: "GET" | "POST" = "GET", body?: Record<string, unknown>) {
  const { data } = method === "POST"
    ? await apiClient.post(url, body ?? { pageNumber: 1, pageSize: 100 })
    : await apiClient.get(url);
  if (data?.data?.items || data?.items) return unwrapPagedItems<T>(data).items;
  const unwrapped = unwrapApiResponse<T[] | unknown>(data);
  return Array.isArray(unwrapped) ? unwrapped as T[] : [];
}

export async function deleteResource(url: string, id: string | number) {
  const { data } = await apiClient.delete(`${url}/${id}`);
  return data;
}
